import {Component, input, output} from '@angular/core';
import {AudioService} from '../../../../../services/audio/audio.service';
import {SongInfoComponent} from '../song-info/song-info.component';
import {DescriptionPanelComponent} from '../description-panel/description-panel.component';
import {PlayerControlsComponent} from '../player-controls/player-controls.component';
import {LoadingOverlayComponent} from '../loading-overlay/loading-overlay.component';

interface Song {
  title: string;
  artist: string;
}

@Component({
  selector: 'app-content-area',
  standalone: true,
  imports: [
    SongInfoComponent,
    DescriptionPanelComponent,
    PlayerControlsComponent,
    LoadingOverlayComponent
  ],
  templateUrl: './content-area.component.html',
  styleUrl: './content-area.component.scss'
})
export class ContentAreaComponent {
  // Inputs for parent component data
  currentSong = input<Song | null>(null);
  currentDescription = input<string>('');
  hasAudioResults = input<boolean>(false);
  isLoadingAlternatives = input<boolean>(false);
  audioResults = input<any[]>([]);
  audioService = input<AudioService | null>(null);
  showInitialLoading = input<boolean>(false);

  // Outputs for parent component actions
  requestAlternativePrompt = output<void>();
  playPreviousSong = output<void>();
  playNextSong = output<void>();
  volumeUpdated = output<number>();

  // Handle request for alternative prompt
  handleRequestAlternativePrompt(): void {
    this.requestAlternativePrompt.emit();
  }

  // Handle play previous song
  handlePlayPreviousSong(): void {
    this.playPreviousSong.emit();
  }

  // Handle play next song
  handlePlayNextSong(): void {
    this.playNextSong.emit();
  }

  // Handle volume update
  handleVolumeUpdated(volume: number): void {
    this.volumeUpdated.emit(volume);
  }

  // Handle play/pause toggle
  handleTogglePlayPause(): void {
    if (this.audioService()) {
      this.audioService()!.togglePlayPause();
    }
  }
}
